import styled, { css } from 'styled-components';

export const Container = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.layout.spacing(1.5)};
    border: none;
    background: none;
    cursor: pointer;

    svg {
      font-size: 1.25rem;
      color: ${theme.palette.primary.main};
      transition: all 0.2s;
    }

    &:hover svg {
      color: ${theme.palette.primary.light};
    }

    span {
      color: ${theme.palette.text.main};
      font-family: ${theme.typography.family};
      font-size: ${theme.typography.sizes.body1};
      font-weight: ${theme.typography.weight.light};
    }
  `}
`;
